// extracted by mini-css-extract-plugin
export default {"fullWidth":"qm-z","image":"rm-z","lazyLoadPicture":"sm-z","lazyLoadSpinner":"tm-z","lazyLoadSpin":"um-z","lazyLoadImage":"vm-z","hasStyledAspectRatio":"wm-z"};